import ActionStatus from '@sunbit-dev/common/enums/ActionStatus';
import ApplicationError from '@sunbit-dev/common/models/ApplicationError';
import sunbitApi from '../services/sunbitApi';
import CommonThunk from '../models/CommonThunk';
import DocumentTypes, { DocumentTypesTypes } from '@sunbit-dev/common/enums/DocumentTypes';
import IDocument from '@sunbit-dev/common/models/IDocument';

export enum ActionTypes {
  LoadApplicationDocument = 'LoadApplicationDocument',
}

const loadApplicationDocumentPending = (documentType: DocumentTypesTypes) => ({
  type: ActionTypes.LoadApplicationDocument,
  status: ActionStatus.Pending,
  documentType
});

export const loadApplicationDocumentSuccess = (document: IDocument, documentType: DocumentTypesTypes) => ({
  type: ActionTypes.LoadApplicationDocument,
  status: ActionStatus.Success,
  documentType,
  document,
});

const loadApplicationDocumentFailure = (error: ApplicationError) => ({
  type: ActionTypes.LoadApplicationDocument,
  status: ActionStatus.Failure,
  error
});

export const loadApplicationDocumentThunk = (document: string):CommonThunk => {
  return async (dispatch) => {
    dispatch(loadApplicationDocumentPending(document as DocumentTypesTypes));
    try {
      let documentResponse:IDocument;
      if (document === DocumentTypesTypes.CardApplicationSolicitationDisclosures) {
        documentResponse = await sunbitApi.getStaticDocument(DocumentTypes[document as DocumentTypesTypes]);
      }else if (sunbitApi.isApplicationIdReady()){
        documentResponse = await sunbitApi.getApplicationDocument(DocumentTypes[document as DocumentTypesTypes]);
      } else {
        return
      }
      dispatch(loadApplicationDocumentSuccess(documentResponse, document as DocumentTypesTypes));
    } catch (error) {
      dispatch(loadApplicationDocumentFailure(error as ApplicationError));
    }
  }
}

export type Actions =
  ReturnType<typeof loadApplicationDocumentPending> |
  ReturnType<typeof loadApplicationDocumentSuccess> |
  ReturnType<typeof loadApplicationDocumentFailure>
;

export type LoadApplicationDocumentSuccess = ReturnType<typeof loadApplicationDocumentSuccess>;
